export default "__VITE_ASSET__DhyDVb7K__"